<template>
    <div class="BROCHURE">

        <div class="content">

            <div class="contentdiv">

                <div @click="setimglist('one')">
                 <img :src="Main.imgserve+'/EBrochure/MAIN_AvenueSouthResidences.jpg'" alt="">
                 <span style="margin-top: 2vh;">Avenue South</span>
                 <span>Main Brochure</span>

                </div>

                <div @click="setimglist('two')">
                    <img :src="Main.imgserve+'/EBrochure/PEAK_Collection.jpg'" alt="">
                 <span style="margin-top: 2vh;">Peak Residences</span>

                </div>
                <div @click="setimglist('three')">
                    <img :src="Main.imgserve+'/EBrochure/HORIZON_collection.jpg'" alt="">
                 <span style="margin-top: 2vh;">Horizon Residences</span>

                </div>
            </div>

        </div>

        <div class="pop" v-if="poptype">
            <!-- <div  @click="poptype = !poptype" style=" position: absolute; width: 100%; height: 100%;"></div> -->

            <div @click="poptype = !poptype" style=" position: absolute;right: 2vw; top: 2vh;width: 2vw;">
                <img :src="Main.imgserve+'/btn/BACK.png'" alt="">
            </div>
            <div style=" position: absolute;right: 4vw; bottom: 6vh;width: 120px;">
                <img :src="`${Main.imgserve}/EBrochure/${nowbook}.svg`" alt="">
            </div>
          <flipbook class="flipbook" :zooms="[1]" :pages="imglist"></flipbook>

        </div>
        <!-- <div class="left_imgcontent"></div> -->
    </div>
</template>

<script>

import Flipbook from 'flipbook-vue'


export default {
    components:{
        Flipbook
    },

data() {
        return {
            nowbook:'',
            poptype:false,
            imglist:["",],
            testlist: [
        "",
        "img/EBrochure/1.jpg",
        
      ],
        }
    },
    methods:{
        setimglist(indexs){
            this.nowbook = indexs
            this.poptype = !this.poptype
            this.imglist = ['',]
            this.editimglist(indexs)
        },
        editimglist(indexs){
            if(indexs == 'one'){
            for (let index = 1; index < 82; index++) {
                // const element = array[index];
                var iterator = `${this.Main.imgserve}/EBrochure/${indexs}/${index}.jpg`
                // console.log(iterator)
                this.imglist.push(iterator);
            }
        }else if(indexs == 'two'){
        for (let index = 1; index < 42; index++) {
            // const element = array[index];
            var iterator = `${this.Main.imgserve}/EBrochure/${indexs}/${index}.jpg`
            // console.log(iterator)
            this.imglist.push(iterator);
        }
        }else{
        for (let index = 1; index < 50; index++) {
            // const element = array[index];
            var iterator = `${this.Main.imgserve}/EBrochure/${indexs}/${index}.jpg`
            // console.log(iterator)
            this.imglist.push(iterator);
        }
        }

        }
    },
    mounted(){
        this.editimglist('one')
    }
}
</script>

<style lang="less">
    
.BROCHURE{
    width: 100%;
    height: 100%;
    margin: 0;
    .content{
        width: 90%;
        height: 100%;

        .contentdiv{
            width: 100%;
            height: 100%;
            display:flex;
            justify-content: center;
            align-items:center;
            div {
            width: 45%;
            margin: auto;
            display:flex;
            flex-flow: column;
            justify-content: center;
            align-items:center;
            img{
                width: 20vw;
            }
            }
        //     .flipbook {
        //     width: 100%;
        //     height: 100%;
        // // width: 90vw;
        // // height: 90vh;
        // /* background: white; */
        // }
        }
    }
    .pop{
        position: fixed;
        top: 0;
        left: 0;
        background: white;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
        // display: none;
    }

}


.flipbook {
// width: 100%;
// height: 100%;
width: 90vw;
height: 90vh;
/* background: white; */
}

.bounding-box {
    position: relative !important;
    box-shadow: 0 0 12px #000;
}
// .container {
//   max-width: 100% !important;
// }
// .flipbook-container{
//   width: 100%;
//   height: 100%;
// }


.manual-wrap {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
  -webkit-transition: opacity ease 0.5s;
  transition: opacity ease 0.5s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.manual-wrap {
  width: 100%;
  height: 100%;
}
.manual-warp {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.manual-wrap.active {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}


</style>